import {defineMessages} from 'react-intl';

export default defineMessages({
	selectColorHeading: {
		id: 'flyouts.colorSelectorFlyout.title',
		defaultMessage: 'Select color'
	},
	tileError: {
		id: 'flyouts.colorSelectorFlyout.tileError',
		defaultMessage: 'Product currently not available'
	},
	notifyMeError: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.'
	},
	notifyMeSuccess: {
		id: 'popups.notifyMe.success',
		defaultMessage: 'Thanks, your request has been saved.'
	},
});